
import { defuFn } from '/home/forge/dreamjobs.hu/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
